import React, { memo } from "react";
import classNames from "classnames";

import "./skeleton.scss";

export interface ISkeletonBarProps {
  width?: string;
  height?: string;
  className?: string;
  style?: React.CSSProperties;
}

function SkeletonBarImpl({ width, height, className, style }: ISkeletonBarProps) {
  const merged: React.CSSProperties = { ...style };
  if (width !== undefined) {
    merged.width = width;
  }
  if (height !== undefined) {
    merged.height = height;
  }

  return <span className={classNames("ui-skeleton-bar", className)} style={merged} aria-hidden />;
}

export const SkeletonBar = memo(SkeletonBarImpl);
SkeletonBar.displayName = "SkeletonBar";
